// components/FormCanvas.jsx
import React, { useEffect } from "react";
import FieldRenderer from "./FieldRenderer";
import { returnPageImage } from "..";

const FormCanvas = ({
  index,
  formDetail,
  classes,
  isRendered,
  setbindFieldsCount,
  handleFieldClick,
  adminDetails,
}) => {
  const handleGetMultilineSubFields = (fields) => {
    let newFields = fields?.filter(
      (it) =>
        it?.type === "multiline" &&
        it.fields_collection?.find((col) => col.page_number === index)
    );
    if (newFields?.length) {
      return newFields.map((element) => ({
        ...element,
        fields_collection: element?.fields_collection?.filter(
          (col) => col.page_number === index
        ),
      }));
    } else {
      return [];
    }
  };

  useEffect(() => {
    if (formDetail?.data?.total_pages) {
      // Clear existing fields before re-rendering

      const myNode = document.getElementById(`fieldWrap${index}`);
      if (myNode) {
        myNode.innerHTML = "";
      }
      addFields(
        {
          ...formDetail.data,
          form_fields: formDetail.data?.form_fields
            ?.filter(
              (it) => it?.page_number === index && it?.type !== "multiline"
            )
            .concat(handleGetMultilineSubFields(formDetail.data?.form_fields)),
        },
        index
      );
    }
  }, [formDetail?.data?.id, formDetail?.data?.form_fields]);

  const addFields = (data, index) => {
    var countField = 0;
    if (formDetail?.data?.file) {
      const pdfDoc = returnPageImage(formDetail?.data?.file, index);
      var canvas = document.getElementById(`myCanvas${index}`);
      canvas.style.width = "100%";
      var ctx = canvas.getContext("2d");
      loadImage(pdfDoc, canvas, ctx, index, data).then((count) => {
        setbindFieldsCount(count);
      });
    }
    return countField;
  };

  const loadImage = (src, canvas, ctx, index, data) =>
    new Promise((resolve, reject) => {
      let img = new Image();
      img.onload = () => {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        if (data?.form_fields?.length) {
          Promise.all(
            data.form_fields.map((field) => {
              return FieldRenderer.renderField(
                field,
                canvas.offsetLeft,
                canvas.offsetTop + canvas.height,
                index,
                handleFieldClick,
                adminDetails?.role?.name === "Admin" ? true : false
              );
            })
          ).then(() => {
            resolve(data.form_fields.length);
          });
        } else {
          resolve(0);
        }
      };
      img.onerror = reject;
      img.src = src;
    });

  return (
    <div className={classes.mPosition} key={index}>
      <canvas id={`myCanvas${index}`} className={classes.mCanvas}></canvas>
      <div id={`fieldWrap${index}`} className={classes.mColor}></div>
    </div>
  );
};

export default FormCanvas;
